export default function RefundForm({ order }) {
  if (!['refund_requested', 'refunded'].includes(order.status) && !['refund_requested', 'refunded'].includes(order.paymentStatus)) return null;
  return <p className="admin-refund-state"><strong>Refund workflow:</strong> {order.paymentStatus.replaceAll('_', ' ')}. Record “refunded” only after the applicable payment or business process is confirmed.</p>;
}
